import { invoke } from '@tauri-apps/api/core';
import { listen, type UnlistenFn } from '@tauri-apps/api/event';
import type { HostConnection } from './host';

/** Serviço ViewerHost instalado e em execução. */
export function serviceRunning(): Promise<boolean> {
  return invoke<boolean>('service_running');
}

/** Envia uma mensagem de sinalização crua pelo agente. */
export function agentWsSend(json: string): Promise<void> {
  return invoke('agent_ws_send', { json });
}

/** `null` remove a senha. Quem grava e confere é o agente. */
export function agentSetPassword(password: string | null): Promise<void> {
  return invoke('agent_set_password', { password });
}

/** `null` sai da conta. O agente refaz o `hello` com o token novo. */
export function agentSetUserToken(token: string | null): Promise<void> {
  return invoke('agent_set_user_token', { token });
}

export function onAgentWs(handler: (json: string) => void): Promise<UnlistenFn> {
  return listen<string>('agent:ws', (e) => handler(e.payload));
}

export function onAgentPassword(handler: (enabled: boolean) => void): Promise<UnlistenFn> {
  return listen<{ enabled: boolean }>('agent:password', (e) => handler(e.payload.enabled));
}

export function onAgentStatus(handler: (online: boolean) => void): Promise<UnlistenFn> {
  return listen<{ online: boolean }>('agent:status', (e) => handler(e.payload.online));
}

/** Sessões Host do agente; chega a cada mudança e quando o app se conecta. */
export function onAgentHostSessions(handler: (sessions: HostConnection[]) => void): Promise<UnlistenFn> {
  return listen<HostConnection[]>('agent:host-sessions', (e) => handler(e.payload));
}
